<style scoped>
    .frequency {box-shadow: 1px 1px 5px #e0e0e0;font-size: 18px;line-height: 35px;border: 1px solid #e0e0e0;margin:10px 20px 10px 20px;display: inline-block;}
    .number {margin-right: 45px;color: red;}
    .sevendays {width: 20px;height: 20px;background-color: rgb(87, 147, 243);}
    .people {vertical-align: top;margin-top: -1px;margin-left: 9px;color: rgb(0, 0, 0);}
    .lvwa_texe {width: 100%;border-bottom: 1px solid rgb(202, 202, 202);height: 30px;line-height: 30px;text-align: center;}
    .lvwa_texe div {width: 33%;}
    .jump_page {width: 50px;height: 30px;border: solid 1px rgb(202, 202, 202);border-radius: 4px;text-align: center;margin: 0 4px 0 10px;}
    .lvwa_texe1 {width: 100%;border-bottom: 1px solid rgb(202, 202, 202);height: 30px;line-height: 30px;text-align: center;}
    .lvwa_texe1 div {
        width: 22%;
        white-space: nowrap;
        overflow: hidden;
    }
    .vertical-center-modal{display: flex;align-items: center;justify-content: center;}
</style>

<template>
    <div class="newlyAdded" style="overflow-y: scroll;">
        <div style="padding: 20px;">
            <div class="frequency">
                <span style="margin-left: 20px">今日新增：</span>
                <span style="color: red;">{{signinData.daycount}}</span><span class="number">人</span>
                <span style="">总注册：</span>
                <span style="color: red;">{{signinData.count}}</span><span class="number">人</span>
                <span style="">律师：</span>
                <span style="color: red;">{{signinData.lawcount}}</span><span class="number">人</span>
                <span style="">普通用户：</span>
                <span style="color: red;">{{signinData.usercount}}</span><span class="number">人</span>
                <div style="display: inline-block;cursor:pointer" @click="modal12 = true">
                    <span style="">总注册律师全国城市覆盖率：</span>
                    <span style="color: red;">{{location_row}}</span><span class="number">%</span>
                </div>
            </div>
            <!--注册人数-->
            <div class="whole">
                <h1>最新注册数据</h1>
                <DatePicker type="daterange" split-panels placeholder="Select date" style="width: 200px"
                            @on-change="handleChange"
                ></DatePicker>
                <div class="inline-block lvwa_texe">
                    <div class="inline-block">日期</div>
                    <div class="inline-block">新增</div>
                    <div class="inline-block">累计总数</div>
                </div>
                <div class="data_list1">
                    <div class="lvwa_texe" v-for="(value,index) in Datalist">
                        <div class="inline-block">{{index}}</div>
                        <div class="inline-block" @click="law_added(index,'new');modal11 = true">{{value.day_num}}人</div>
                        <div class="inline-block" @click="law_added(index,'total');modal11 = true">{{value.total}}人</div>
                    </div>
                </div>
                <!--下一页-->
                <div class="page1" style="text-align: right; margin-top: 30px; color: rgb(51, 122, 183);">
                    <div class="inline-block ye">{{page}}  /  {{total_page}}   </div>
                    <a href="javascript:;" class="inline-block" @click="business(prev_page)" style="margin-left: 10px;">
                        <div class="inline-block">上一页</div>
                    </a>
                    <input type="text" class="jump_page inline-block" v-model="page">
                    <a href="javascript:;" class="inline-block" @click="business(page)" >
                        <div class="click_junp inline-block">跳转</div>
                    </a>
                    <a href="javascript:;" class="inline-block" @click="business(next_page)">
                        <div class="inline-block">下一页</div>
                    </a>
                </div>
                <!---->
            </div>
            <!--折线图-->
            <div class="switchNew">
                <a href="javascript:;" @click="visit(1)">
                    <div class="inline-block"><div class="inline-block sevendays"></div>
                        <p class="inline-block people">近7天注册人数</p>
                    </div>
                </a>
                <a href="javascript:;" @click="visit(2)">
                    <div class="inline-block" style="margin: 0 30px">
                        <div class="inline-block sevendays" style="background-color: #e1604e"></div>
                        <p class="inline-block people">近7周注册人数</p>
                    </div>
                </a>
                <a href="javascript:;">
                    <div @click="visit()" class="inline-block">
                        <div class="inline-block sevendays" style="background-color: #675bba"></div>
                        <p class="inline-block people">
                            <select style=" width: 170px;" id="status_select" name="">
                                <option value="0">2019年月注册人数</option>
                            </select>
                        </p>
                    </div>
                </a>
            </div>
            <!--折线图-->
            <div class="inline-block" id="number" :style="{width: '100%', height: '500px'}"></div>
            <!--使用量-->
            <div>
                <h1>使用功能数据分析</h1>
                <div class="tota15">
                    <div class="frequency">
                        <span style="margin-left: 20px">点赞：</span>
                        <span style="color: red;">{{like_count.nums}}</span><span class="number">次</span>
                        <span >访问：</span>
                        <span style="color: red;">{{visit_count.nums}}</span><span class="number">次</span>
                        <span style="">消息：</span>
                        <span style="color: red;">{{message_count.nums}}</span><span class="number">条</span>
                        <span style="">关注数：</span>
                        <span style="color: red;">{{focus_count.nums}}</span><span class="number">次</span>
                        <span style="">粉丝数：</span>
                        <span style="color: red;">{{fans_count.nums}}</span><span class="number">次</span>
                        <span style="">下载次数：</span>
                        <span style="color: red;">{{down_count.nums}}</span><span class="number">次</span>
                        <span style="">分享次数：</span>
                        <span style="color: red;">{{share_count.nums}}</span><span class="number">次</span>
                        <span style="">拨打电话：</span>
                        <span style="color: red;">{{call_count.nums}}</span><span class="number">次</span>
                    </div>
                    <div id="choice1" style="padding-top: 20px;">
                        <a href="javascript:;" @click="getDays()"><div class="inline-block"><div class="inline-block sevendays"></div>
                            <p class="inline-block people">近7天新增使用量</p></div>
                        </a>
                        <a href="javascript:;" @click="getWeeks()"><div class="inline-block" style="margin: 0 50px">
                            <div class="inline-block sevendays" style="background-color: #e1604e"></div><p class="inline-block people">近7周新增使用量</p></div>
                        </a>
                        <a href="javascript:;">
                            <div @click="getMonths()" class="inline-block"><div class="inline-block sevendays" style="background-color: #675bba"></div>
                                <p class="inline-block people"><select style=" width: 170px;" id="status_select" name=""><option value="0">2019年月新增使用量</option>
                                </select></p></div>
                        </a>
                    </div>
                    <div class="inline-block" id="myChart" :style="{width: '100%', height: '500px'}"></div>

                </div>
            </div>
            <div>
                <h1>用户活跃度</h1>
                <div class="switchNew">
                    <a href="javascript:;" @click="activeUserDay()">
                        <div class="inline-block"><div class="inline-block sevendays"></div>
                            <p class="inline-block people">近30天用户活跃度</p>
                        </div>
                    </a>
                    <a href="javascript:;" @click="activeUserWeek()">
                        <div class="inline-block" style="margin: 0 30px">
                            <div class="inline-block sevendays" style="background-color: #e1604e"></div>
                            <p class="inline-block people">近30周用户活跃度</p>
                        </div>
                    </a>
                    <a href="javascript:;">
                        <div @click="activeUserMonth()" class="inline-block">
                            <div class="inline-block sevendays" style="background-color: #675bba"></div>
                            <p class="inline-block people">
                                <select style=" width: 170px;" id="status_select" name="">
                                    <option value="0">2019年月用户活跃度</option>
                                </select>
                            </p>
                        </div>
                    </a>
                </div>
                <div class="inline-block" id="numberDay" :style="{width: '100%', height: '500px'}"></div>
            </div>
        </div>
        <!--弹出内容-->
        <Modal v-model="modal12"  title="占比数据" width="100%" footer-hide>
            <div style="height: 500px;overflow-x: hidden;overflow-y: scroll;width: 70%;display: inline-block">
                <div class="inline-block" id="region" :style="{width: '70%', height: '500px'}"></div>
                <div class="inline-block" id="region1" :style="{width: '70%', height: '500px'}"></div>
            </div>
            <div class="inline-block" style="height: 500px;overflow-x: hidden;overflow-y: scroll;width: 30%;display: inline-block">
                <div class="inline-block" style="width: 100%;"  v-for="(value,index) in location_rows">
                    <div style="width: 100%;border-bottom: 1px solid rgb(202, 202, 202);height: 28px;line-height: 28px;">
                        <span>{{index}}：</span>
                        <span style="color:red;margin-left: 20px;">{{value}}个</span>
                    </div>
                </div>
            </div>
        </Modal>
        <!--弹出2-->
        <Modal v-model="modal11"  title="" width="100%" footer-hide>
            <div class="inline-block lvwa_texe1" style="text-align: left;">
                <div class="inline-block" style="text-align: left;width: 15%;margin-left: 20px;">名称</div>
                <div class="inline-block" style="text-align: left;width: 10%;">地址</div>
                <div class="inline-block" style="width: 10%">电话</div>
                <div class="inline-block" style="width: 15%">领域</div>
                <div class="inline-block" style="width: 15%">所属律所</div>
                <div class="inline-block" style="width: 10%">微律号</div>
                <div class="inline-block" style="width: 10%">注册时间</div>
                <div class="inline-block" style="width: 10%">查看更多</div>
            </div>
            <div style="height: 500px;overflow: hidden scroll;">
                <div class="inline-block lvwa_texe1" style="text-align: left;" v-for="(value,index) in listData">
                    <div class="inline-block" style="text-align: left;width: 15%;margin-left: 20px;" :title="value.nickname">{{value.nickname}}</div>
                    <div class="inline-block" style="text-align: left;width: 10%;" :title="value.pname-value.cname">{{value.pname}}-{{value.cname}}</div>
                    <div class="inline-block" style="width: 10%" :title="value.mobile">{{value.mobile}}</div>
                    <div class="inline-block" style="width: 15%" :title="value.law_key">{{value.law_key}}</div>
                    <div class="inline-block" style="width: 15%" :title="value.law_place">{{value.law_place}}</div>
                    <div class="inline-block" style="width: 10%" :title="value.wmid">{{value.wmid}}</div>
                    <div class="inline-block" style="width: 10%" :title="value.register_time">{{value.register_time}}</div>
                    <a href="javascript:;"><div class="inline-block" style="width: 10%" @click="getDays1(index);modal13 = true">查看更多</div></a>
                </div>
            </div>

        </Modal>
        <Modal v-model="modal13"  title="" width="100%" footer-hide>
            <div style="height: 550px;">
                <div id="choice1" style="padding-top: 20px;">
                    <a href="javascript:;" @click="getDays1(id)"><div class="inline-block"><div class="inline-block sevendays"></div>
                        <p class="inline-block people">近7天新增使用量</p></div>
                    </a>
                    <a href="javascript:;" @click="getWeeks1(id)"><div class="inline-block" style="margin: 0 50px">
                        <div class="inline-block sevendays" style="background-color: #e1604e"></div><p class="inline-block people">近7周新增使用量</p></div>
                    </a>
                    <a href="javascript:;">
                        <div @click="getMonths1(id)" class="inline-block"><div class="inline-block sevendays" style="background-color: #675bba"></div>
                            <p class="inline-block people"><select style=" width: 170px;" id="status_select" name=""><option value="0">2019年月新增使用量</option>
                            </select></p></div>
                    </a>
                </div>
                <div class="inline-block" id="myChart1" :style="{width: '100%', height: '500px'}"></div>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "newlyAdded",
        data () {
            return {
                msg: '',
                signinData : '',
                location_row : '',
                location_rows : '',
                location_rowP : '',
            //    弹出
                modal12: false,
                modal11 : false,
                modal13 : false,
                region : {},
                region1 : {},
                siteLine : {},
            //    折线图
                number : {},
                day :[],
                week : [],
                year : [],
            //    使用量
                totals1 : [],
                visit_nums : [],
                messageCount : [],
                like_nums : [],
                focus_nums : [],
                fans_nums : [],
                download_nums : [],
                share_nums : [],
                mobile_nums : [],
                myChart : {},
            //
                call_count : '',
                share_count : '',
                down_count : '',
                fans_count : '',
                focus_count : '',
                message_count : '',
                visit_count : '',
                like_count : '',
            //
                Datalist : '',
                page : '1',
                next_page : '',
                prev_page : '',
                total_page : '',
                valueTime: '',
                listData : [],
                myChart1 : {},
                id : '',
            //
                dayListData : [],
                numberDay : {},
            }
        },
        methods :{
            drawLine(){
                var _this = this
                _this.region = this.$echarts.init(document.getElementById('region'))
                _this.region.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    title : {

                        text: '微律名片-总注册律师全国覆盖率：'+_this.location_row+'%'+'（城市TOP50）',
                        x:'center',
                        y: '0px'
                    },
                    series : [
                        {
                            name: '注册律师地区占比',
                            type: 'pie',
                            radius : '55%',
                            center: ['50%', '60%'],
                            //隐藏标示线和标示文字
                            itemStyle : {
                                normal : {
                                    label : {
                                        show : true,
                                        formatter: '{b} :  ({d}%)'
                                    },
                                    labelLine : {
                                        show : true
                                    }
                                },

                            },

                            data:(function(){
                                var _location = [];
                                // var _this = this
                                for(var i in _this.location_rows){
                                    if(_location.length < 50){
                                        _location.push({
                                            name: i,
                                            value: _this.location_rows[i]
                                        });
                                    }
                                }
                                return _location;
                            })()
                        },
                    ]
                });

                // _this.region.resize(resize);
            },
            //省地区
            drawLine1(){
                var _this = this
                _this.region1 = this.$echarts.init(document.getElementById('region1'))
                _this.region1.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    title : {

                        text: '微律名片-总注册律师各个省占比',
                        x:'center',
                        y: '0px'
                    },
                    series : [
                        {
                            name: '注册律师地区占比',
                            type: 'pie',
                            radius : '55%',
                            center: ['50%', '60%'],
                            //隐藏标示线和标示文字
                            itemStyle : {
                                normal : {
                                    label : {
                                        show : true,
                                        formatter: '{b} :{c}人 ({d}%)'
                                    },
                                    labelLine : {
                                        show : true
                                    }
                                },

                            },

                            data:(function(){
                                var _location = [];
                                // var _this = this
                                for(var i in _this.location_rowP){
                                    if(_location.length < 50){
                                        _location.push({
                                            name: i,
                                            value: _this.location_rowP[i]
                                        });
                                    }
                                }
                                return _location;
                            })()
                        },
                    ]
                });

                // _this.region.resize(resize);
            },
            lawRegisterd : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/lawRegisterd',
                    data: {},
                    success: function (res) {
                        _this.signinData = res
                        _this.location_rows = res.location_rows
                        _this.location_rowP = res.location_rowP
                        var num = res.location_row/370*100
                        _this.location_row = num.toFixed(2)
                        //    弹出
                        _this.drawLine()
                        _this.drawLine1()

                    }
                })
            },
            lawRegister : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/lawRegister',
                    success: function (res) {
                        // var _this = this
                        _this.day = res.day
                        _this.week = res.week
                        _this.year = res.year
                        _this.visit(1)

                    }
                })
            },
        //    折线图
            visit : function (type) {
                var _this = this
                var law_day = []
                var dateOne = []
                if(type == 1){
                    for(var i in _this.day){
                        law_day.push(_this.day[i])
                        dateOne.push(i)
                    }
                    var _colour = '#5793f3'
                }if(type == 2){
                    for(var i in _this.week){
                        law_day.push(_this.week[i])
                        dateOne.push(i)
                    }
                    var _colour = '#e1604e'
                }if(type == undefined){
                    for(var i in _this.year){
                        for (var index in _this.year[i]){
                            law_day.push(_this.year[i][index])
                            dateOne.push(index)
                            law_day.splice(12,12);
                            dateOne.splice(12,12);
                        }

                    }
                    var _colour = '#675bba'
                }
                console.log(law_day)
                var colors = [_colour];
                //
                _this.number = this.$echarts.init(document.getElementById('number'))
                _this.number.setOption({
                    color: colors,
                    tooltip: {
                        trigger: 'none',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    grid: {
                        top: 70,
                        bottom: 50
                    },
                    title : {
                        text: '新增注册人数（天/周/月）',
                        x:'left',
                    },
                    xAxis: [
                        {
                            name: '日期',
                            type: 'category',
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLine: {
                                onZero: false,
                                lineStyle: {
                                    color: colors[0]
                                }
                            },
                            axisPointer: {
                                label: {
                                    formatter: function (params) {
                                        return  params.value + '新增访问人数'
                                            + (params.seriesData.length ? '：' + params.seriesData[0].data : '')+'人  ';
                                    }
                                }
                            },
                            data: dateOne
                        }
                    ],
                    yAxis: [
                        {
                            name: '人数',
                            type: 'value',
                            minInterval:1,
                        }
                    ],
                    series: [
                        {
                            type:'line',
                            // smooth: true,
                            smooth: false,
                            data: law_day,
                            label: {//top的数值
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        }
                    ]
                })
            },
            //使用量数
            totals : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/totals',
                    success: function (res) {
                        _this.call_count = res.call_count
                        _this.share_count = res.share_count
                        _this.down_count = res.down_count
                        _this.fans_count = res.fans_count
                        _this.focus_count = res.focus_count
                        _this.message_count = res.message_count
                        _this.visit_count = res.visit_count
                        _this.like_count = res.like_count
                    }
                })
            },
        //    日
            getDays : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/getDays',
                    success: function (res) {
                        _this.register1(res.day_visit,res.day_message,res.day_like,res.day_focus,res.day_fans,res.day_down,res.day_share,res.day_call)
                    }
                })
            },
            // 周
            getWeeks : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/getWeeks',
                    success: function (res) {
                        _this.register1(res.week_visit,res.week_message,res.week_like,res.week_focus,res.week_fans,res.week_down,res.week_share,res.week_call)
                    }
                })
            },
        //    月
            getMonths : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/getMonths',
                    success: function (res) {
                        _this.register1(res.month_visit[0],res.month_message[0],res.month_like[0],res.month_focus[0],res.month_fans[0],res.month_down[0],res.month_share[0],res.month_call[0])
                    }
                })
            },
            register1 : function (day_visit,day_message,day_like,day_focus,day_fans,day_down,day_share,day_call) {
                var _this = this
                var date = []//底部日期
                var visit_nums = []//访问量
                var messageCount = []//信息
                var like_nums = []//点赞
                var focus_nums = []// 关注数
                var fans_nums = []//粉丝数
                var download_nums = []//下载次数
                var share_nums = []//分享次数
                var mobile_nums = []//拨打电话
                for(var i in day_visit){
                    visit_nums.push(day_visit[i])
                    date.push(i)
                    visit_nums.splice(12,12)
                    date.splice(12,12)
                }
                //信息
                for(var i in day_message){
                    messageCount.push(day_message[i])
                    messageCount.splice(12,12)
                }
                //点赞
                for(var i in day_like){
                    like_nums.push(day_like[i])
                    like_nums.splice(12,12)
                }
                // 关注数
                for(var i in day_focus){
                    focus_nums.push(day_focus[i])
                    focus_nums.splice(12,12)
                }
                //粉丝数
                for(var i in day_fans){
                    fans_nums.push(day_fans[i])
                    fans_nums.splice(12,12)
                }
                //下载次数
                for(var i in day_down){
                    download_nums.push(day_down[i])
                    download_nums.splice(12,12)
                }
                //分享次数
                for(var i in day_share){
                    share_nums.push(day_share[i])
                    share_nums.splice(12,12)
                }
                //拨打电话
                for(var i in day_call){
                    mobile_nums.push(day_call[i])
                    mobile_nums.splice(12,12)
                }
                // 基于准备好的dom，初始化echarts实例
                this.myChart = this.$echarts.init(document.getElementById('myChart'))
                // 绘制图表
                var datanums = []
                var visit = []
                // datanums.push(visit_count,message_count,like_count,focus_count,fans_count,down_count,share_count,call_count)
                console.log(visit_nums,date)
                this.myChart.setOption({

                        title: {
                            text: '新增使用数量'
                        },
                        tooltip: {
                            trigger: 'axis',
                            hideDelay: '10000',
                        },
                        legend: {
                            data:['访问','消息','点赞','关注数','粉丝数','下载次数','分享次数','拨打电话']
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        toolbox: {
                            feature: {
                                saveAsImage: {}
                            }
                        },
                        xAxis: {
                            name: '日期',
                            type: 'category',
                            boundaryGap: false,
                            //时间显示
                            data: date
                        },
                        yAxis: {
                            name: '数',
                            type: 'value',
                        },
                        series: [
                            {
                                name:'访问',
                                type:'line',
                                data:visit_nums
                            },
                            {
                                name:'消息',
                                type:'line',
                                data:messageCount
                            },
                            {
                                name:'点赞',
                                type:'line',
                                data:like_nums
                            },
                            {
                                name:'关注数',
                                type:'line',
                                data:focus_nums
                            },
                            {
                                name:'粉丝数',
                                type:'line',
                                data:fans_nums
                            },
                            {
                                name:'下载次数',
                                type:'line',
                                data:download_nums
                            },
                            {
                                name:'分享次数',
                                type:'line',
                                data:share_nums
                            },
                            {
                                name:'拨打电话',
                                type:'line',
                                data:mobile_nums
                            }
                        ]

                });
            },
            getLawDate : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/getLawDate',
                    data: {page: _this.page,date: _this.valueTime},
                    success: function (res) {
                        if(res.result == 200){

                        }else {
                            _this.Datalist = res.list
                            _this.next_page = res.next_page
                            _this.page = res.page
                            _this.prev_page = res.prev_page
                            _this.total_page = res.total_page
                        }

                    }
                })
            },
            handleChange:function (date) {
                var _this = this
                _this.page = '1'
                _this.valueTime = date[0] +' - '+ date[1];
                _this.getLawDate()
            },
            business : function (page) {
                var _this = this
                _this.page = page
                _this.getLawDate()
            },
            law_added : function (index,type) {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/lawInfor',
                    data: {date: index,
                        page: _this.page,
                        type: type},
                    success: function (res) {
                        _this.listData = res.list
                    }
                })
            },
            getDays1 : function (index) {
                var _this = this
                _this.id = index
                _this.send({
                    server : 'ai',
                    data : {law_id:index},
                    url : '/get_law_day',
                    success: function (res) {
                        _this.seeHedo(res.day_visit,res.day_message,res.day_like,res.day_focus,res.day_fans,res.day_down,res.day_share,res.day_call)
                    }
                })
            },
            getWeeks1 : function (index) {
                var _this = this
                _this.id = index
                _this.send({
                    server : 'ai',
                    data : {law_id:index},
                    url : '/get_law_week',
                    success: function (res) {
                        _this.seeHedo(res.week_visit,res.week_message,res.week_like,res.week_focus,res.week_fans,res.week_down,res.week_share,res.week_call)
                    }
                })
            },
            getMonths1 : function (index) {
                var _this = this
                _this.id = index
                _this.send({
                    server : 'ai',
                    url : '/get_law_month',
                    success: function (res) {
                        _this.seeHedo(res.month_visit[0],res.month_message[0],res.month_like[0],res.month_focus[0],res.month_fans[0],res.month_down[0],res.month_share[0],res.month_call[0])
                    }
                })
            },
            seeHedo : function (day_visit,day_message,day_like,day_focus,day_fans,day_down,day_share,day_call) {
                var _this = this
                var date = []//底部日期
                var visit_nums = []//访问量
                var messageCount = []//信息
                var like_nums = []//点赞
                var focus_nums = []// 关注数
                var fans_nums = []//粉丝数
                var download_nums = []//下载次数
                var share_nums = []//分享次数
                var mobile_nums = []//拨打电话
                for(var i in day_visit){
                    visit_nums.push(day_visit[i])
                    date.push(i)
                    visit_nums.splice(12,12)
                    date.splice(12,12)
                }
                //信息
                for(var i in day_message){
                    messageCount.push(day_message[i])
                    messageCount.splice(12,12)
                }
                //点赞
                for(var i in day_like){
                    like_nums.push(day_like[i])
                    like_nums.splice(12,12)
                }
                // 关注数
                for(var i in day_focus){
                    focus_nums.push(day_focus[i])
                    focus_nums.splice(12,12)
                }
                //粉丝数
                for(var i in day_fans){
                    fans_nums.push(day_fans[i])
                    fans_nums.splice(12,12)
                }
                //下载次数
                for(var i in day_down){
                    download_nums.push(day_down[i])
                    download_nums.splice(12,12)
                }
                //分享次数
                for(var i in day_share){
                    share_nums.push(day_share[i])
                    share_nums.splice(12,12)
                }
                //拨打电话
                for(var i in day_call){
                    mobile_nums.push(day_call[i])
                    mobile_nums.splice(12,12)
                }
                // 基于准备好的dom，初始化echarts实例
                this.myChart1 = this.$echarts.init(document.getElementById('myChart1'))
                // 绘制图表
                var datanums = []
                var visit = []
                // datanums.push(visit_count,message_count,like_count,focus_count,fans_count,down_count,share_count,call_count)
                console.log(visit_nums,date)
                this.myChart1.setOption({

                    title: {
                        text: '新增使用数量'
                    },
                    tooltip: {
                        trigger: 'axis',
                        hideDelay: '10000',
                    },
                    legend: {
                        data:['访问','消息','点赞','关注数','粉丝数','下载次数','分享次数','拨打电话']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        name: '日期',
                        type: 'category',
                        boundaryGap: false,
                        //时间显示
                        data: date
                    },
                    yAxis: {
                        name: '数',
                        type: 'value',
                    },
                    series: [
                        {
                            name:'访问',
                            type:'line',
                            data:visit_nums
                        },
                        {
                            name:'消息',
                            type:'line',
                            data:messageCount
                        },
                        {
                            name:'点赞',
                            type:'line',
                            data:like_nums
                        },
                        {
                            name:'关注数',
                            type:'line',
                            data:focus_nums
                        },
                        {
                            name:'粉丝数',
                            type:'line',
                            data:fans_nums
                        },
                        {
                            name:'下载次数',
                            type:'line',
                            data:download_nums
                        },
                        {
                            name:'分享次数',
                            type:'line',
                            data:share_nums
                        },
                        {
                            name:'拨打电话',
                            type:'line',
                            data:mobile_nums
                        }
                    ]

                });
            },
            activeUserDay : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/activeUserDay',
                    success: function (res) {
                        _this.dayListData = res.List
                        _this.dayData(1)
                        console.log(res )
                    }
                })
            },
            activeUserWeek : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/activeUserWeek',
                    success: function (res) {
                        _this.dayListData = res.List
                        _this.dayData(2)
                        console.log(res )
                    }
                })
            },
            activeUserMonth : function(){
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/activeUserMonth',
                    success: function (res) {
                        _this.dayListData = res.List
                        _this.dayData()
                        console.log(res )
                    }
                })
            },
            dayData : function (type) {
                var _this = this
                var law_day = []
                var dateOne = []
                if(type == 1){
                    for(var i in _this.dayListData){
                        law_day.push(_this.dayListData[i])
                        dateOne.push(i)
                    }
                    var _colour = '#5793f3'
                }if(type == 2){
                    for(var i in _this.dayListData){
                        law_day.push(_this.dayListData[i])
                        dateOne.push(i)
                    }
                    var _colour = '#e1604e'
                }if(type == undefined){
                    for(var i in _this.dayListData){
                        for (var index in _this.dayListData[i]){
                            law_day.push(_this.dayListData[i][index])
                            dateOne.push(index)
                            law_day.splice(12,12);
                            dateOne.splice(12,12);
                        }

                    }
                    var _colour = '#675bba'
                }
                console.log(law_day)
                var colors = [_colour];
                //
                _this.numberDay = this.$echarts.init(document.getElementById('numberDay'))
                _this.numberDay.setOption({
                    color: colors,
                    tooltip: {
                        trigger: 'none',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    grid: {
                        top: 70,
                        bottom: 50
                    },
                    title : {
                        text: '用户活跃（天/周/月）',
                        x:'left',
                    },
                    xAxis: [
                        {
                            name: '日期',
                            type: 'category',
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLine: {
                                onZero: false,
                                lineStyle: {
                                    color: colors[0]
                                }
                            },
                            axisPointer: {
                                label: {
                                    formatter: function (params) {
                                        return  params.value + '用户活跃人数'
                                            + (params.seriesData.length ? '：' + params.seriesData[0].data : '')+'人  ';
                                    }
                                }
                            },
                            data: dateOne
                        }
                    ],
                    yAxis: [
                        {
                            name: '人数',
                            type: 'value',
                            minInterval:1,
                        }
                    ],
                    series: [
                        {
                            type:'line',
                            // smooth: true,
                            smooth: false,
                            data: law_day,
                            label: {//top的数值
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        }
                    ]
                })
            },
            timeObtain : function () {
                var _this = this
                var mydate=new Date();
                var myddy=mydate.getDay();//获取存储当前日期
                var date = new Date(); //日期对象

                _this.now = date.getFullYear()+"-"; //读英文就行了
                _this.now = _this.now + (date.getMonth())+"-"; //取月的时候取的是当前月-1如果想取当前月+1就可以了
                _this.now = _this.now + (date.getDate())+" - ";
                _this.now1 = date.getFullYear()+"-"; //读英文就行了
                _this.now1 = _this.now1 + (date.getMonth()+1)+"-"; //取月的时候取的是当前月-1如果想取当前月+1就可以了
                _this.now1 = _this.now1 + (date.getDate())+"";
                _this.valueTime = _this.now + _this.now1
                console.log(_this.valueTime)
            }
        },
        mounted () {
            var _this = this
            //获取时间
            this.timeObtain()
            //律师注册人数
            this.lawRegisterd()
            //今日新增
            this.lawRegister();
            //使用量
            this.totals()
            //
            this.getDays()
            //使用列表
            this.getLawDate()
            //活跃
            this.activeUserDay()
            // let region = this.$echarts.init(document.getElementById('region'))
            window.onresize = function() {
                _this.number.resize();
            }
            setInterval(
                window.onresize = function() {
                    _this.region.resize();
                    _this.region1.resize();
                    _this.number.resize();
                    // _this.myChart1.resize();
                }
                , 1000);
            },
    }
</script>


